/**
 * Checkbox List that adds a checkmark icon to each list item
 * the List Element with „checkboxList” class be created through CKEditor → Styles → Dropdown
 * @example
 * ``` twig
 * <div is="component"></div>"
 * {% include "_/atoms/checkboxList/index.twig" %}
 * ```
 *
 * ``` scss
 * [is="component"] {
 *  > .icon-checkmark {
 *    display: none;
 *    }
 * }
 * ```
 */
export const checkboxList = () => {
  const components = Array.from(
    document.querySelectorAll('[is]:has(ul.checkboxList)')
  );
  const checkmarkIcon: HTMLElement = document.querySelector(
    '.icon-checkmark [is="atom-icon"]'
  );

  components.forEach((component) => {
    const listItems: HTMLLIElement[] = Array.from(
      component.querySelectorAll('ul.checkboxList > li')
    );

    listItems.forEach((listItem) => {
      const innerHtml = listItem.innerHTML;
      const wrapperForContent = document.createElement('span');
      wrapperForContent.innerHTML = innerHtml;
      listItem.innerHTML = '';
      listItem.append(checkmarkIcon.cloneNode(true));
      listItem.append(wrapperForContent);
    });

    checkmarkIcon.remove();
  });
};
